import {ITask} from "../GorevYoneticisiTypes";

export abstract class AbstractTaskHandler {
    public abstract handle(task: ITask): Promise<ITask>;
}